/*
 * This file is the JS equivalent of the app/Enumerations/EventType.php file.
 *
 * Comments are completely acceptable in this file, as its primarily for interface between product and engineering,
 * as a single easy place to see what (primarily) trackable events we have, and have an easy way to compare this to amplitude/segment.
 *
 * https://app.amplitude.com/data/tettra/tettra.co/events/main
 *
 *
 * */

const CLICKED_SEARCH_RESULT = 'Clicked search result';
/* When a user clicks a search result */
/* https://github.com/search?q=repo%3ATettra%2Ftettra-wiki%20EVENT_TYPE.CLICKED_SEARCH_RESULT&type=code */

const CLICKED_ADVANCED_SEARCH = 'Clicked advanced search';
/* When a user clicks a search result */
/* https://github.com/search?q=repo%3ATettra%2Ftettra-wiki%20EVENT_TYPE.CLICKED_ADVANCED_SEARCH&type=code */

const CLICKED_CREATE_QUESTION = 'Clicked show create question';
/* When a user clicks ask a question from the search modal */
/* https://github.com/search?q=repo%3ATettra%2Ftettra-wiki%20EVENT_TYPE.CLICKED_CREATE_QUESTION&type=code */

const EDIT_LOCK_MODAL_EDIT_ANYWAY = 'User clicked edit anyway on locking modal';
/* When a user clicks 'edit anyway' on a new draft of a page that has an open draft */
/* https://github.com/search?q=repo%3ATettra%2Ftettra-wiki%20EVENT_TYPE.EDIT_LOCK_MODAL_EDIT_ANYWAY&type=code */

const EDIT_LOCK_MODAL_EDIT_LATER = 'User clicked edit later on locking modal';
/* When a user clicks 'edit later' on a new draft of a page that has an open draft */
/* https://github.com/search?q=repo%3ATettra%2Ftettra-wiki%20EVENT_TYPE.EDIT_LOCK_MODAL_EDIT_LATER&type=code */

const MESSAGE_LOCK_MODAL = 'User clicked message user on locking modal';
/* When a user clicks 'message user' on a new draft of a page that has an open draft */
/* https://github.com/search?q=repo%3ATettra%2Ftettra-wiki%20EVENT_TYPE.MESSAGE_LOCK_MODAL&type=code */

const NEW_REVISION_MODAL = 'User viewed new revision of draft modal';
/* When a user click view new revision in the draft modal */
/* https://github.com/search?q=repo%3ATettra%2Ftettra-wiki%20EVENT_TYPE.NEW_REVISION_MODAL&type=code */

const OPENED_SEARCH_MODAL = 'User opened search modal';
/* When a user opens the search modal */
/* https://github.com/search?q=repo%3ATettra%2Ftettra-wiki%20EVENT_TYPE.OPENED_SEARCH_MODAL&type=code */

const EVENT_TYPE = {
    CLICKED_SEARCH_RESULT,
    CLICKED_ADVANCED_SEARCH,
    CLICKED_CREATE_QUESTION,
    EDIT_LOCK_MODAL_EDIT_ANYWAY,
    EDIT_LOCK_MODAL_EDIT_LATER,
    MESSAGE_LOCK_MODAL,
    NEW_REVISION_MODAL,
    OPENED_SEARCH_MODAL
};

export default EVENT_TYPE;
